/**
 * GENERATED CODE
 * this file is generated by the 'process-icons' script.
 */
import React from 'react';
import { createSvgIcon } from '../utils';
export default createSvgIcon(React.createElement("g", { style: { transform: 'scaleY(-1)', transformOrigin: '50% 50%' } },
    React.createElement("path", { d: "M179.2 119.4666666666667C179.2 119.4666666666667 76.8 221.8666666666667 68.2666666666667 230.4S76.8 256 85.3333333333333 247.4666666666667S179.2 153.6 179.2 153.6S418.1333333333334 392.5333333333333 426.6666666666667 401.0666666666667S452.2666666666667 392.5333333333333 443.7333333333334 384S179.2 119.4666666666667 179.2 119.4666666666667z" })), 'Checkmark', '0 0 512 512');
//# sourceMappingURL=CheckmarkIcon.js.map